import { Link } from 'react-router-dom'
import PageHero from '../components/PageHero'
import PageSeo from '../components/PageSeo'
import SiteFooter from '../components/SiteFooter'
import TopNav from '../components/TopNav'
import { buildOrganizationSchema, getAbsoluteUrl } from '../lib/seo'
import './ArticlePage.css'

export default function ContactUsPage() {
  return (
    <div className="article-page">
      <PageSeo
        title="Contact Us | Contrast Shower"
        description="Contact the Contrast Shower team for app support, questions, or just to say hello."
        canonical={getAbsoluteUrl('/contact-us')}
        image={getAbsoluteUrl('/images/blog-placeholder-basics.svg')}
        keywords={['contact contrast shower', 'contrast shower support', 'contact us']}
        schema={[buildOrganizationSchema()]}
      />

      <TopNav />

      <main>
        <article className="article-shell">
          <PageHero as="header" innerClassName="article-hero__inner">
            <nav className="article-breadcrumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Contact Us</span>
            </nav>

            <p className="eyebrow eyebrow--blog">Support</p>
            <h1 className="article-hero__title heading-light">Contact Us</h1>
            <p className="article-hero__description p-intro">Contact us at support@contrastshower.com</p>
          </PageHero>

          <div className="container article-body-wrap">
            <div className="article-layout article-layout--single">
              <div className="article-content article-content--legal">
                <p className="article-intro">Contact us at support@contrastshower.com</p>

                <section className="article-section">
                  <h2>We&apos;re Easy to Reach</h2>
                  <p>
                    If you need a hand with the app, have a question about contrast showers, or just feel like saying hello, send us a note at support@contrastshower.com.
                  </p>
                  <p>
                    We&apos;ll do our best to get back to you as soon as we can.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </article>
      </main>

      <SiteFooter />
    </div>
  )
}
